/**
 * "Prompts & persona" — Dashboard section (ADR-0074).
 * Reconciled from apps/web prompts feature (persona, voice, brand phrases,
 * system prompt, fallback, refusal, reply language).
 */
import type { DocPageContent } from '../types';

export const DASHBOARD_PROMPTS_PAGE: DocPageContent = {
  slug: 'dashboard/prompts',
  titleKey: 'docs.dashboard.prompts.title',
  descriptionKey: 'docs.dashboard.prompts.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.dashboard.prompts.lead' },

    { kind: 'heading', level: 2, id: 'persona', textKey: 'docs.dashboard.prompts.persona.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.prompts.persona.body' },

    { kind: 'heading', level: 2, id: 'system', textKey: 'docs.dashboard.prompts.system.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.prompts.system.body' },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.dashboard.prompts.system.note.title',
      textKey: 'docs.dashboard.prompts.system.note.body',
      links: {
        languages: {
          target: { docSlug: 'languages' },
          labelKey: 'docs.dashboard.prompts.system.note.link',
        },
      },
    },

    {
      kind: 'heading',
      level: 2,
      id: 'fallbacks',
      textKey: 'docs.dashboard.prompts.fallback.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.prompts.fallback.body' },

    {
      kind: 'heading',
      level: 2,
      id: 'language',
      textKey: 'docs.dashboard.prompts.language.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.prompts.language.body' },

    {
      kind: 'heading',
      level: 2,
      id: 'profiles',
      textKey: 'docs.dashboard.prompts.profiles.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.prompts.profiles.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.prompts.profiles.item.templates',
        'docs.dashboard.prompts.profiles.item.versions',
        'docs.dashboard.prompts.profiles.item.compare',
        'docs.dashboard.prompts.profiles.item.transfer',
        'docs.dashboard.prompts.profiles.item.stats',
      ],
    },

    {
      kind: 'heading',
      level: 2,
      id: 'targeting',
      textKey: 'docs.dashboard.prompts.targeting.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.prompts.targeting.body' },
    {
      kind: 'callout',
      tone: 'important',
      titleKey: 'docs.dashboard.prompts.targeting.note.title',
      textKey: 'docs.dashboard.prompts.targeting.note.body',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.prompts.targeting.simulator' },
    {
      kind: 'paragraph',
      textKey: 'docs.dashboard.prompts.targeting.embed',
      links: {
        embed: {
          target: { docSlug: 'widget/configuration' },
          labelKey: 'docs.dashboard.prompts.targeting.embed.link',
        },
      },
    },

    { kind: 'heading', level: 2, id: 'rollout', textKey: 'docs.dashboard.prompts.rollout.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.prompts.rollout.body' },

    {
      kind: 'heading',
      level: 2,
      id: 'statistics',
      textKey: 'docs.dashboard.prompts.statistics.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.prompts.statistics.body' },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.dashboard.prompts.statistics.note.title',
      textKey: 'docs.dashboard.prompts.statistics.note.body',
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.dashboard.prompts.next.knowledge.title',
          textKey: 'docs.dashboard.prompts.next.knowledge.text',
          to: { docSlug: 'dashboard/knowledge' },
        },
        {
          titleKey: 'docs.dashboard.prompts.next.catalog.title',
          textKey: 'docs.dashboard.prompts.next.catalog.text',
          to: { docSlug: 'dashboard/catalog' },
        },
      ],
    },
  ],
};
